var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import './filterPanel.scss';
import { UuiFlexlayout } from '@aonunited/react';
import { AonMultiSelect, } from '../../../components/core/AonMultiSelect';
import { useAppInfoStore, useErrorStore, useRecentChangesStore } from '../../../store';
import { AonButton } from '../../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../../components/core/AonButton/consts';
import { AonRadioButton } from '../../../components/core/AonRadioButton';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { getExcelReport } from '../../../api/recentChanges';
import React from 'react';
import { Tooltip } from '../../../components/ToolTip/ToolTip';
import { useNavigate } from 'react-router-dom';
var RecentChangesFilterPanel = (observer(function (props) {
    var appInfo = useAppInfoStore();
    var recentChangesStore = useRecentChangesStore();
    var errorStore = useErrorStore();
    var navigation = useNavigate();
    var _a = recentChangesStore.filterpanelStates, region = _a.region, marketId = _a.marketId, country = _a.country, month = _a.month;
    var handleRegions = function (event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        var id = event.detail;
        if (id) {
            if (appInfo.country) {
                var country_1 = (_a = appInfo.country) === null || _a === void 0 ? void 0 : _a.filter(function (cn) { return id.includes(cn.regionId.toString()); });
                recentChangesStore.setSeletedCountry(country_1);
            }
            recentChangesStore.setFilterPanelStore("region", id);
            setTimeout(function () { return recentChangesStore.setFilterPanelStore("country", []); }, 500);
        }
        else {
            recentChangesStore.setFilterPanelStore("region", id);
            recentChangesStore.setSeletedCountry([]);
            setTimeout(function () { return recentChangesStore.setFilterPanelStore("country", []); }, 500);
        }
    };
    var handleMarketTypeChange = function (event) {
        updateSelect("marketId", event.detail);
    };
    var updateSelect = function (key, value) {
        //if (key === "country") {
        //  const findCountry = appInfo.country?.filter(country =>  value.includes(country.countryId.toString()))?.map(country=>country.regionId);
        //  const findRegion = appInfo.regions?.filter(region =>findCountry?.includes(region.id))?.map(region=>region.id.toString());
        // setTimeout(() => recentChangesStore.setFilterPanelStore("region", findRegion), 500);
        //if (appInfo.country) {
        //    let country = appInfo.country?.filter(cn => findRegion?.includes(cn.regionId.toString()))
        //     recentChangesStore.setSeletedCountry(country);
        //  }
        //  }
        recentChangesStore.setFilterPanelStore(key, value);
    };
    var filterUnique = function (data) {
        var existing = [];
        return data.filter(function (item) {
            if (existing.includes(item.marketTypeCategoryDesc)) {
                return false;
            }
            else {
                existing.push(item.marketTypeCategoryDesc);
                return true;
            }
        });
    };
    var exportDataToExelFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var getMarketIds, response, binaryString, byteArray, i, blob, link, error_1, message, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    getMarketIds = function () {
                        var _a;
                        var _ids = [];
                        if (marketId) {
                            (_a = appInfo.marketType) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                                if (marketId.includes(item.marketTypeCategoryDesc)) {
                                    _ids.push(item.marketTypeId);
                                }
                            });
                        }
                        return _ids.length ? _ids.join(",") : undefined;
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getExcelReport({ marketTypeIds: getMarketIds(), regionIds: region === null || region === void 0 ? void 0 : region.join(","), countryIds: country === null || country === void 0 ? void 0 : country.join(","), fromDurationMonth: month })];
                case 2:
                    response = _a.sent();
                    binaryString = atob(response.data.content);
                    byteArray = new Uint8Array(binaryString.length);
                    for (i = 0; i < binaryString.length; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }
                    blob = new Blob([byteArray], { type: response.data.mimeType });
                    link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = response.data.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log("error");
                    message = error_1.message, status = error_1.status;
                    errorStore.showError({ message: message, code: status });
                    navigation('/error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderContry = recentChangesStore.selectedCountry.length ? recentChangesStore.selectedCountry : appInfo.country;
    return (React.createElement(React.Fragment, null,
        React.createElement(UuiFlexlayout, { direction: 'row', className: 'ratings-filter-wrapper' },
            React.createElement(AonMultiSelect, { state: appInfo.marketType ?
                    filterUnique(appInfo.marketType).map(function (item) {
                        return ({ label: item.marketTypeCategoryDesc, value: item.marketTypeCategoryDesc });
                    }) : [], defaultValue: 'Market Type', handelChecked: handleMarketTypeChange, selectedList: marketId }),
            React.createElement(AonMultiSelect, { defaultValue: 'Region', selectedList: region || [], handelChecked: handleRegions, state: __spreadArray([], appInfo.regions ? appInfo.regions.map(function (item) {
                    return ({ label: item.name, value: item.id.toString() });
                }) : [], true) }),
            React.createElement(AonMultiSelect, { defaultValue: 'Country', selectedList: country || [], handelChecked: function (event) { return updateSelect("country", event.detail); }, state: __spreadArray([], renderContry ? renderContry.map(function (item) {
                    return ({ label: item.description, value: item.countryId.toString() });
                }) : [], true) }),
            React.createElement("div", null,
                React.createElement("div", { style: { display: "flex", width: "400PX", justifyContent: 'space-between' } },
                    React.createElement(AonRadioButton, { style: { padding: "8px" }, checked: month === 1, value: 1, onToggleChange: function (event) { return updateSelect("month", event.target.value); } }, "One Month"),
                    React.createElement(AonRadioButton, { style: { padding: "8px" }, checked: month === 2, value: 2, onToggleChange: function (event) { return updateSelect("month", event.target.value); } }, "Two Months"),
                    React.createElement(AonRadioButton, { style: { padding: "8px" }, checked: month === 3, value: 3, onToggleChange: function (event) { return updateSelect("month", event.target.value); } }, "Three Months"))),
            React.createElement("div", { className: 'search-pannel' },
                React.createElement(UuiFlexlayout, { direction: 'row', gap: 'xs' },
                    React.createElement(AonButton, { variant: BUTTON_VARIANT.DEFAULT, onClick: props.onClickSearch }, "Search"))),
            React.createElement("div", null,
                React.createElement(Tooltip, { content: "Export to Excel", direction: "left" },
                    React.createElement("div", { onClick: exportDataToExelFile },
                        React.createElement(FontAwesomeIcon, { style: { fontSize: "28px", color: "green", cursor: "pointer" }, icon: faFileExcel })))))));
}));
export default RecentChangesFilterPanel;
